<template>
	<div>
		<div class="filter-wrap">
			<el-button type="primary" @click='showDialog("add")' v-if='operations.includes("新增标签")'>新增标签</el-button>
		</div>
		
		<div class="table-wrap">
			<el-table :data="tableData" border style="width: 100%">
				<el-table-column prop="name" label="标签名" align="center"></el-table-column>
				<el-table-column label="操作" align="center">
					<template slot-scope="scope">
						<span class="operation-text" @click='showDialog("delete",scope)' v-if='operations.includes("删除标签")'>删除</span>
						<span class="operation-text" @click='showDialog("edit",scope)' v-if='operations.includes("编辑标签")'>编辑</span>
					</template>
				</el-table-column>
			</el-table>
			<common-pagination :total="total" :page_size="page_size" @size-change="handelPagesizeChange" @page-change="handlePageChange"></common-pagination>
		</div>
		
		<common-dialog :title="dialogTitle" :dialogVisible="dialogVisible" @cancel="dialogVisible = false" @confirm="dialogConfirmClick">
			<div v-if="dialogType =='delete'">
			  是否删除标签？
			</div>
            <div class="input-item" v-else>
				<el-input type="textarea" :autosize="{ minRows: 5, minCols:20}" v-model="name" maxlength="32" show-word-limit placeholder="请输入标签内容"></el-input>
			</div>
		</common-dialog>
	</div>
</template>

<script>
	import CommonPagination from "@/components/CommonPagination";
	import CommonDialog from "@/components/CommonDialog";
	import {getQuickTagList,addQuickTag,editQuickTag,deleteQuickTag} from "@/api/tag";
	import utils from "@/jslibs/utils";
	import operations from '@/mixins/operations';
    import Sortable from "sortablejs";
	export default {
		mixins: [operations],
		data() {
			return {
				page_index:"1",
				page_size:"10",
				tableData:[],
				total:0,
				uuid:"",
				dialogVisible:false,
                dialogType:"",
                dialogTitle:"",
				name:"",
				tag_type:"quick"
			}
		},
		
		mounted() {
			this.getQuickTagList();
            this.setSort();
		},
		methods: {
            setSort(){
                const tbody = document.querySelector('.el-table__body-wrapper tbody')
                Sortable.create(tbody,{
                    ghostClass: "sortable-ghost",    // drop placeholder的css类名
                    dragClass: "sortable-drag",      // 正在被拖拽中的css类名
                    setData:function(dataTransfer){
                        dataTransfer.setData('Text', '');
                        console.log(dataTransfer,"111111");
                    },
                    onEnd: evt => {
                        console.log(evt,"10101010")
                    }
                })
            },
			async getQuickTagList() {
				let postData = {
					page_index: this.page_index,
					page_size: this.page_size,
					tag_type: this.tag_type
				};
				const {data,status} = await getQuickTagList(postData);
				if (status !== 200) return;
				this.tableData = data.data;
				this.total = data.total;
			},

			handelPagesizeChange(size) {
				this.page_size = size;
				this.getQuickTagList();
			},
			handlePageChange(page) {
				this.page_index = page;
				this.getQuickTagList();
			},
            
            showDialog(type,scope){
                if(type == "delete"){
                    this.dialogTitle = "删除标签";
					this.uuid = scope.row.uuid
                }
                else if(type == "edit"){
                    this.dialogTitle = "编辑标签";
					this.uuid = scope.row.uuid;
					this.name = scope.row.name;
                }
				else if(type == "add"){
				    this.dialogTitle = "新增标签";
					this.name = "";
				}
                this.dialogType = type;
                this.dialogVisible = true;
            },

			async dialogConfirmClick() {
				if(this.dialogType == "delete"){
					const { status,data } = await deleteQuickTag(this.uuid);
					if (status == 200){
						if(data.success == "success"){
							this.$message.success("标签删除成功");
						}else{
							this.$message.error("系统繁忙");
							return
						}
					}
				}
				else{
					if(!this.name){
						this.$message("请输入标签内容");
						return
					}
					if(this.dialogType == "add"){
						let postData = {name: this.name,tag_type: this.tag_type};
						const { status,data }= await addQuickTag(postData);
						if (status === 200) {
							if(data.success == "success"){
								this.$message.success("标签新增成功");
							}else{
								this.$message.error("系统繁忙");
								return
							}
						}
					}
					else{
						let postData = {name: this.name,uuid:this.uuid,tag_type: this.tag_type};
						const { status,data }= await editQuickTag(postData);
						if (status === 200) {
							if(data.success == "success"){
								this.$message.success("编辑标签成功");
							}else{
								this.$message.error("系统繁忙");
								return
							}
						}
					}
				}  
				this.getQuickTagList();
				this.dialogVisible = false;
			}
		},
		
		components: {
			CommonPagination,
			CommonDialog
		},
	};
</script>

<style lang="less" scoped>
	@import "~@/assets/styles/variables.less";
	.filter-wrap {
		display: flex;
		justify-content: flex-end;
	}

	.table-wrap {
		margin-top: 20px;
		.operation-text {
			color: @color-text;
			margin-right: 15px;
			cursor: pointer;
		}
	}
    /deep/.sortable-drag{
        color:#ccc;
        background: #fff;
    }
    /deep/.sortable-ghost{
        background: rgba(64,158,255,0.8);
    }
</style>
